module.exports = __webpack_public_path__ + "img/user-profile-icon.95ade774.svg";